import {
  PaymentMethodsConfigurationDto,
  ProviderRateDto,
} from '@tiendanube/common';
import { customPaymentsIds } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { CUSTOM_PAYMENTS_IMPROVEMENTS_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';

export interface Result {
  filteredRates: ProviderRateDto[];
  customPaymentCpt: string;
}

export const useFilterRates = (
  providerId: string,
  rates: ProviderRateDto[],
  paymentMethodsConfiguration?: PaymentMethodsConfigurationDto,
): Result => {
  const [hasCustomPaymentsImprovementsTag] = useHasTags(
    CUSTOM_PAYMENTS_IMPROVEMENTS_TAG,
  );

  if (!paymentMethodsConfiguration) {
    return {
      filteredRates: rates,
      customPaymentCpt: '-',
    };
  }
  const availablePaymentMethods =
    paymentMethodsConfiguration?.paymentMethodAvailability ?? [];
  const isCustomPaymentProvider = customPaymentsIds.includes(providerId);

  function mustShowRate(paymentMethods: string[]) {
    if (
      !hasCustomPaymentsImprovementsTag ||
      !isCustomPaymentProvider ||
      !paymentMethodsConfiguration ||
      paymentMethodsConfiguration.maxSelectableTypes === -1
    ) {
      return true;
    }
    return availablePaymentMethods.some(
      ({ name, isAvailable }) => paymentMethods.includes(name) && isAvailable,
    );
  }

  const customPaymentCpt =
    availablePaymentMethods.find(({ name }) => name === 'other')?.cptFee ?? '-';

  const filteredRates = rates.filter(({ paymentMethods }) =>
    mustShowRate(paymentMethods),
  );

  return {
    filteredRates,
    customPaymentCpt,
  };
};
